var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data && _vm.data.length > 0)?_c('van-swipe',{staticClass:"mall-banner",attrs:{"autoplay":"5000","indicator-color":"#fff","width":"100%"}},_vm._l((_vm.data),function(item,index){return _c('van-swipe-item',{key:index},[_vm._t("default",null,{"item":item,"index":index})],2)}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }